<template>
  <div class="chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

export default {
  props: {
    datasets: {
      type: Array,
      required: true,
      default: () => []
    },
    xFrom: {
      type: Number,
      default: 83
    },
    xTo: {
      type: Number,
      default: 95
    },
    yFrom: {
      type: Number,
      default: 2000
    },
    yTo: {
      type: Number,
      default: 2500
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
  methods: {
    initChart() {
      const canvas = this.$refs.chartCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctx, {
        type: 'scatter',
        data: { datasets: this.datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: 'top',
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
                font: {
                  size: 14
                }
              }
            },
            tooltip: {
              enabled: true
            },
          },
          scales: {
            y: {
              type: 'linear',
              min: this.yFrom,
              max: this.yTo,
              ticks: {
                stepSize: 100,
                font: {
                  size: 14
                },
                callback: function(value) {
                  return value.toLocaleString();
                }
              },
              grid: {
                drawBorder: false
              }
            },
            x: {
              type: 'linear',
              min: this.xFrom,
              max: this.xFrom + 9,
              ticks: {
                stepSize: 1,
                font: {
                  size: 14
                },
                callback: function(value) {
                  if (value >= 83 && value <= 95) return value;
                  return '';
                }
              },
              grid: {
                display: true,
                drawBorder: false
              }
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.chart-container {
  /* width: 100%; */
  /* height: 400px; */
  margin: 20px 0;
  font-family: Arial, sans-serif;
}

canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}
</style>